<script lang="ts">
  // test
  import Data from "../Data.svelte";
</script>

<h3 class="modal_heading">
  <i class="fas fa-exclamation-circle" />
  Finished Staking V1
</h3>

<Data label="What is affected">
  <small class="modal_p white_text">
    Staking period for this staking contract has ended and no more rewards will be earned for staking. Please unstake and restake into the new staking contract to continue accruing rewards.
  </small>
</Data>

<small class="modal_p white_text">For further questions feel free to reach out on official telegram:
  <a href="https://t.me/KudoeOfficial"> Official Dogs of Elon </a>
</small>

<style>
  h3 {
    margin-top: 0px;
  }

  pre {
    background-color: var(--button-color);
    color: var(--button-text-color);
    padding: 10px;
    border-radius: var(--border-radius);
    word-wrap: break-word;
    white-space: pre-wrap;
  }

  i {
    font-size: 0.9rem;
    opacity: 0.5;
  }
</style>
